import type { GossipItem } from "@/mocks/gossip";
import { hotRank } from "@/mocks/gossip";

interface Props {
  items: GossipItem[];
  onRead: (item: GossipItem) => void;
}

export default function HotBoard({ items, onRead }: Props) {
  const picks = [items[3], items[5], items[8]].filter(Boolean);

  return (
    <section id="rank" className="scroll-mt-20 bg-secondary-100/50">
      <div className="mx-auto max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-fire-line text-base" aria-hidden="true"></i>
              TRENDING NOW
            </p>
            <h2 className="mt-2 text-3xl font-bold text-foreground-950 md:text-4xl">瓜摊热榜 · 大家都在看</h2>
          </div>
          <a href="#hot" className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600 sm:inline-flex">
            返回今日瓜田
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <ol className="divide-y divide-background-200 rounded-3xl bg-background-50 px-5 md:px-7">
              {hotRank.map((r) => (
                <li key={r.rank}>
                  <a
                    href="#hot"
                    className="group flex items-center gap-4 py-4"
                    aria-label={`热度第${r.rank}名`}
                  >
                    <span
                      className={`font-display-head w-9 shrink-0 text-center text-2xl leading-none ${
                        r.rank <= 3 ? "text-primary-500" : "text-background-400"
                      }`}
                    >
                      {r.rank}
                    </span>
                    <span className="flex-1">
                      <span className="block text-[15px] font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                        {r.title}
                      </span>
                      <span className="mt-1.5 inline-flex items-center gap-3 text-xs text-foreground-500">
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-fire-fill text-secondary-500" aria-hidden="true"></i>
                          {r.heat} 热度
                        </span>
                        {r.up ? (
                          <span className="inline-flex items-center gap-0.5 text-accent-600">
                            <i className="ri-arrow-up-line text-sm" aria-hidden="true"></i>较昨日上升
                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-0.5 text-foreground-400">
                            <i className="ri-arrow-down-line text-sm" aria-hidden="true"></i>较昨日回落
                          </span>
                        )}
                      </span>
                    </span>
                    <i className="ri-arrow-right-s-line text-xl text-background-300 transition-all group-hover:-translate-x-0.5 group-hover:text-primary-500" aria-hidden="true"></i>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-5">
            <div className="flex h-full flex-col justify-between rounded-3xl bg-foreground-950 p-7 text-background-50 md:p-9">
              <div>
                <p className="inline-flex items-center gap-2 rounded-full bg-accent-500/20 px-3 py-1 text-xs font-medium text-accent-300">
                  <i className="ri-edit-2-line" aria-hidden="true"></i>
                  今日编辑部精选
                </p>
                <ul className="mt-6 space-y-4">
                  {picks.map((item) => (
                    <li key={item.id}>
                      <button
                        type="button"
                        onClick={() => onRead(item)}
                        className="group block w-full text-left"
                      >
                        <span className="block text-sm font-semibold leading-snug text-background-50 transition-colors group-hover:text-accent-300">
                          {item.title}
                        </span>
                        <span className="mt-2 flex items-center gap-3 text-xs text-foreground-300">
                          <span className="inline-flex items-center gap-1">
                            <i className="ri-time-line" aria-hidden="true"></i>
                            {item.time}
                          </span>
                          <span>{item.tag}</span>
                        </span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              <blockquote className="mt-8 border-l-2 border-accent-500 pl-4">
                <p className="text-sm leading-relaxed text-foreground-200">
                  「吃瓜最要紧的是分辨，爆料网想把『每一口瓜』都讲清楚来龙去脉，而不是只图热闹。理性吃瓜，瓜更甜。」
                </p>
                <footer className="mt-3 text-xs text-foreground-400">—— 爆料网 编辑部</footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}